var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhoneDisconnect = function SvgIconPhoneDisconnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.274 8.274a13.76 13.76 0 0 1 19.452 0 5.5 5.5 0 0 1 .46 7.252 1.74 1.74 0 0 1-2.04.55l-4.437-1.772a1.77 1.77 0 0 1-1.057-1.251l-.003-.014-.552-2.645a6.87 6.87 0 0 0-4.23.011L9.35 13.03a1.77 1.77 0 0 1-1.057 1.273l-.01.004-4.43 1.77a1.74 1.74 0 0 1-2.04-.552 5.5 5.5 0 0 1 .46-7.251M12 6.248a11.76 11.76 0 0 0-8.311 3.44 3.5 3.5 0 0 0-.404 4.462l4.132-1.65.517-2.634.003-.014a1.75 1.75 0 0 1 1.137-1.29 8.87 8.87 0 0 1 5.822-.01l.008.003a1.74 1.74 0 0 1 1.123 1.294l.552 2.649 4.136 1.652a3.5 3.5 0 0 0-.403-4.461A11.76 11.76 0 0 0 12 6.248m-8.6 8.06-.001-.002z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 18.75a1 1 0 0 1 1-1h16.5a1 1 0 0 1 0 2H3.75a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconPhoneDisconnect;